<template>
	<div class="container mx-auto p-4">
		<h1 class="text-2xl font-bold mb-4">
			Số lượng đăng ký: {{ list_candidates.total }}
		</h1>
		<h1 class="text-2xl font-bold mb-4">
			Đã chấm: {{ list_candidates.data.filter(candidate => candidate.my_grading[0].point != 0 || candidate.my_grading[1].point != 0).length }}
		</h1>
		<el-collapse class="grid grid-cols-1 gap-4">
			<el-collapse-item
				v-for="(entry, index) in list_candidates.data"
				:key="entry.id"
				:name="index"
				class="bg-white p-4 rounded shadow-md border mt-3"
			>
				<template slot="title">
					<h2 class="text-xl font-semibold mb-2">{{ entry.name }} <i
						v-if="entry.my_grading[0].point != 0 || entry.my_grading[1].point != 0"
						class="nucleo nucleo-c-check text-solid-green-1 ml-1"/><i
						v-if="entry.my_grading[0].point == 0 && entry.my_grading[1].point == 0"
						class="nucleo nucleo-c-remove-2 text-solid-red ml-1"/> Điểm: {{ entry.my_grading[0].point }} +
						{{ entry.my_grading[1].point }} = {{ entry.my_grading[0].point + entry.my_grading[1].point }}
					</h2>
				</template>
				<p class="text-gray-700"><strong>Địa chỉ email:</strong> {{ entry.email }}</p>
				<p class="text-gray-700"><strong>Ngày sinh:</strong> {{ formatDate(entry.dob) }}</p>
				<p class="text-gray-700"><strong>Giới tính:</strong> {{ entry.gender ? "Nam" : "Nữ" }}</p>
				<p class="text-gray-700"><strong>Dân tộc:</strong> {{ entry.ethnic }}</p>
				<p class="text-gray-700"><strong>Số điện thoại:</strong> {{ entry.phone }}</p>
				<p class="text-gray-700"><strong>Đối tượng:</strong> {{ entry.subject }}</p>
				<p class="text-gray-700"><strong>Trúng tuyển trường:</strong> {{ entry.university }}</p>
				<p class="text-gray-700"><strong>Chương trình đào tạo:</strong> {{ entry.training_program }}</p>
				<p class="text-gray-700"><strong>Ngành trúng tuyển:</strong> {{ entry.specialization }}</p>
				<p class="text-gray-700"><strong>Phương thức xét tuyển:</strong> {{ entry.admission }}</p>
				<p class="text-gray-700"><strong>Điểm trúng tuyển:</strong> {{ entry.point }}</p>
				<p class="text-gray-700"><strong>Bạn có anh/chị nào đã hoặc đang ở KTX:</strong>
					{{ entry.relative_in_domitory }}</p>
				<p class="text-gray-700"><strong>Hoàn cảnh gia đình:</strong> {{ entry.family_condition }}</p>
				<p class="text-gray-700"><strong>Định hướng và ước mơ:</strong> {{ entry.orient }}</p>
				<p class="text-gray-700"><strong>Thành tích học tập:</strong> {{ entry.academic_achievement }}</p>
				<p class="text-gray-700"><strong>Ảnh nhà:</strong> <a :href="entry.home_url" target="_blank"
																	  class="text-blue-600 underline">Xem ảnh</a></p>
				<hr class="my-3">
				<div class="grid grid-cols-1 sm:grid-cols-2 gap:2 sm:gap-4">
					<div class="mb-3">
						<label class="text-gray-700 font-semibold block mb-1">Điểm tiêu chí về gia cảnh:</label>
						<vs-input
							type="number"
							v-model="entry.my_grading[0].point"
							class="w-full"
							:name="'family_point_' + entry.id"
							data-vv-as="Điểm tiêu chí về gia cảnh"
							v-validate="'required|between:0,10|integer'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('family_point_' + entry.id)">
							{{ errors.first('family_point_' + entry.id) }}
						</span>
					</div>
					<div class="mb-3">
						<label class="text-gray-700 font-semibold block mb-1">Điểm tiêu chí về học lực:</label>
						<vs-input
							type="number"
							v-model="entry.my_grading[1].point"
							class="w-full"
							:name="'academy_point_' + entry.id"
							data-vv-as="Điểm tiêu chí về học lực"
							v-validate="'required|between:0,5|integer'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('academy_point_' + entry.id)">
							{{ errors.first('academy_point_' + entry.id) }}
						</span>
					</div>
				</div>

				<div class="flex justify-center flex-wrap items-center">
					<vs-button @click="saveGrading(entry, entry.my_grading)" class="w-full sm:w-1/3 font-bold">
						Lưu điểm
					</vs-button>
				</div>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>
<script>
import gql from "graphql-tag";
import graphqlCmcard from "@/http/graphql/card";

export default {
	data() {
		return {
			list_candidates: [],
		};
	},
	methods: {
		formatDate(timestamp) {
			const date = new Date(timestamp);
			const day = String(date.getDate()).padStart(2, '0');
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const year = date.getFullYear();
			return `${day}/${month}/${year}`;
		},
		async saveGrading(candidate, grading) {
			this.$validator
				.validateAll()
				.then(async result => {
					if (result) {
						const points = JSON.stringify(grading.map(item => ({
							criteria_id: item.criteria_id,
							point: item.point,
						})));

						const mutation = gql`
							mutation GradingCandidate($candidateId: Int!, $points: String) {
								grading_candidate(candidate_id: $candidateId, points: $points) {
									candidate_id
									criteria_id
									point
									created_at
									updated_at
								}
							}
						`;

						const variables = {
							candidateId: candidate.id,
							points: points,
						};

						try {
							const response = await graphqlCmcard.mutate({mutation, variables});
							this.list_candidates = {
								...this.list_candidates,
								data: this.list_candidates.data.map(item => {
									if (item.id === candidate.id) {
										item.my_grading = response.data.grading_candidate;
									}
									return item;
								})
							}
							this.$helper.notifySuccess({
								context: this,
								options: {
									title: candidate.name,
									text: "Cập nhật điểm thành công"
								}
							});
						} catch (error) {
							this.$helper.notifyError({
								context: this,
								options: {
									title: candidate.name,
									text: "Cập nhật điểm thất bại, vui lòng thử lại sau"
								}
							});
						}
					}
				})
				.catch(() => {
					this.$helper.notifyError({
						context: this,
						options: {
							title: candidate.name,
							text: "Cập nhật điểm thất bại, vui lòng thử lại sau"
						}
					});
				});
		},
		setDefaultGrading(grading) {
			// Kiểm tra và thiết lập giá trị mặc định
			const defaultGrading = [
				{criteria_id: 1, point: 0},
				{criteria_id: 2, point: 0},
			];

			if (!grading || grading.length === 0) {
				return defaultGrading;
			}

			// Nếu thiếu tiêu chí nào thì bổ sung tiêu chí đó
			defaultGrading.forEach((defaultItem, index) => {
				if (!grading[index] || !grading[index].criteria_id) {
					grading[index] = defaultItem;
				} else {
					grading[index].point = grading[index].point || 0;
				}
			});

			return grading;
		}
	},
	async created() {
		const queryOptions = {
			query: gql`
			{
				list_candidates(page: 1, limit: 300, orderBy: { column: "id", direction: "asc" }) {
					data {
						id
						name
						email
						dob
						gender
						ethnic
						religion
						address
						birthplace
						card_id
						card_issue_date
						card_issue_place
						phone
						parent_phone
						facebook_url
						subject
						university
						training_program
						specialization
						admission
						point
						relative_in_domitory
						family_condition
						orient
						academic_achievement
						card_url
						home_url
						my_grading {
							criteria_id
							point
						}
					}
					total
				}
			}`,
		}
		try {
			const response = await graphqlCmcard.query(queryOptions);
			// Thiết lập giá trị mặc định cho mỗi thí sinh
			this.list_candidates = {
				...response.data.list_candidates,
				data: response.data.list_candidates.data.map(candidate => ({
					...candidate,
					my_grading: this.setDefaultGrading(candidate.my_grading),
				})),
			};
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	}
}
</script>
